import 'react-phone-input-2/lib/style.css';

import PhoneInput from 'react-phone-input-2';

// Sole owner of react-phone-input-2's stylesheet, which is 44 KB raw / 24 KB gzip — a third of all
// render-blocking CSS on the home page — mostly one 29 KB base64 sprite of 235 country flags.
//
// It used to be imported by sign-up-modal.tsx, which the header imports statically, so the CSS was
// merged into the /_app stylesheet that every page and every visitor downloads. The phone field is
// doubly conditional: it renders only after a click on "create account" AND only for Brazilian or
// Russian users. Routing every importer through this module keeps the stylesheet in a lazily-loaded
// chunk instead of the critical path.
//
// Import this via next/dynamic — importing it statically from anything the header or _app reaches
// puts the 44 KB straight back into the render-blocking bundle.
export default PhoneInput;
